// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"790":"ckeditor-decoupled","869":"ckeditor-classic"}[chunkId] || chunkId) + "." + {"239":"ad40150f","732":"35ed01f5","790":"9153dae9","869":"3d0d1324","977":"66536321"}[chunkId] + ".chunk.js";
};